import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import DocumentIdentificationTypeService from "../../services/documentIdentificationType/DocumentIdentificationTypeService";
import { loadingDocumentIdentificationTypeDropdown } from "../../store/slices/documentIdentificationType/documentIdentificationTypeSlice";

export const useDocumentIdentificationType = () => {
  const dispatch: AppDispatch = useDispatch();

  const { documentIdentificationTypeDropdown } = useSelector(
    (state: RootState) => state.documentIdentificationType
  );

  const fetchDocumentIdentificationTypeDropdown = async () => {
    try {
      const response = await DocumentIdentificationTypeService.fetchDropdown();
      dispatch(loadingDocumentIdentificationTypeDropdown(response));
    } catch (error) {
      console.error("Error al cargar DocumentIdentificationTypes:", error);
    }
  };

  return {
    documentIdentificationTypeDropdown,
    fetchDocumentIdentificationTypeDropdown,
  };
};
